<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ix"></a>
<div class="break">
<p class="tabcap" id="tab1"><span class="underline">Table I: The Family of Antipater.</span></p>
<p class="tab">A. Sons.</p>
<p class="images"><img alt="Image" src="images/img_pix-1.jpg"/></p>
<p class="tab">B. Daughters.</p>
<p class="images"><img alt="Image" src="images/img_pix-2.jpg"/></p>
<p class="noindent">CAPITALS: Rulers of Macedon (see also <a href="#/xhtml/#tab6">Table VI</a>)</p>
<p class="noindent">Order of birth is uncertain.</p>
</div>
<a id="page_x"></a>
<div class="break">
<p class="tabcap" id="tab2"><span class="underline">Table II: The Family of Antipater’s Eldest Daughter.</span></p>
<p class="images"><img alt="Image" src="images/img_px-1.jpg"/></p>
</div>
<div class="break">
<p class="tabcap" id="tab3"><span class="underline">Table III: The Family of Nikaia.</span></p>
<p class="images"><img alt="Image" src="images/img_px-2.jpg"/></p>
</div>
<a id="page_xi"></a>
<div class="break">
<p class="tabcap" id="tab4"><span class="underline">Table IV: The Families of Eurydike and Berenike.</span></p>
<p class="images"><img alt="Image" src="images/img_pxi.jpg"/></p>
</div>
<a id="page_xii"></a>
<div class="break">
<p class="tabcap" id="tab5"><span class="underline">Table V: The Families of Phila.</span></p>
<p class="images"><img alt="Image" src="images/img_pxii.jpg"/></p>
</div>
<a id="page_xiii"></a>
<div class="break">
<p class="tabcap" id="tab6"><span class="underline">Table VI: The Macedonian Kings, 359 – 239.</span></p>
<p class="images"><img alt="Image" src="images/img_pxiii.jpg"/></p>
</div>
<a id="page_xiv"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_tables.vue?7bb1279a